@if (loading()) {
  <div class="loading-container">
    <span>Carregando...</span>
  </div>
} @else if (scheduleRule()) {
  <app-schedule-rule-card
    [scheduleRule]="scheduleRule()!"
    [shopName]="shopName()"
    [userName]="userName()"
    (toggleActive)="onToggleActive($event)"
    (updateWeekdays)="onUpdateWeekdays($event)"
    (requestUpdateFromAdmin)="onRequestUpdateFromAdmin()"
    (updateSchedulingRequirements)="onUpdateSchedulingRequirements($event)"
  ></app-schedule-rule-card>
  <visio-popup id="schedule-rule-popup"></visio-popup>
} @else {
  <div class="not-found-container">
    <span>Nenhuma regra encontrada para este estabelecimento e câmera.</span>
  </div>
}
